// TODO IMPROVEMENT: Modify backend response for camelCase

export interface IAssetClass {
  id: number;
  name: string;
  derived: boolean;
}

export class AssetClass implements IAssetClass {
  constructor(
    public id: number,
    public name: string,
    public derived: boolean,
  ) {}
}
